import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";

function SendSmsModal({ show, data, onHide }) {
  const [text, setText] = useState("");
  const [validated, setValidated] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const sendSMSCall = useApi(postapi.sendSMS, { hasCatchError: true });

  const close = () => {
    setText("");
    setValidated(false);
    setIsClicked(false);
    onHide();
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsClicked(true);
      setValidated(true);
      if (text.length === 0) throw new Error("Enter message to continue this process.");

      const payload = {
        recipientList: [
          {
            cellNumber: data?.customer_phone,
          },
        ],
        message: text,
        channel: "ATM",
      };

      const response = await sendSMSCall.request({ data: payload });

      if (response) {
        toast.success("SMS sent successfully");
        close();
      }
    } catch (error) {
      setIsClicked(false);
      console.error(error.message);
    }
  };

  return (
    <>
      <Modal aria-labelledby="contained-modal-title-vcenter" centered size="lg" show={show} onHide={close}>
        <Modal.Header className="border-0 pt-3 border-bottom" closeButton={close}>
          <div className="d-flex align-items-center gap-4">
            <h4>{`Send SMS (Order# ${data?.order_number})`}</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control as={"textarea"} value={text} onChange={(e) => setText(e.target.value)} />
            {text.length === 0 && validated ? <span className="text-danger">*Please enter a message</span> : <></>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="outline-primary" style={{ fontSize: "14px" }} onClick={handleSubmit} disabled={isClicked}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendSmsModal;
